
$('.video_wrapper__around').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1
});

$('.video-text-around').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1
});


$('.coll__listing').slick({
  dots: false,
  arrows:true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        infinite: true
      }
    }
  ]
});

$( document ).ready(function() {
  $('.template-product').find('.prod_description button').click();
  $('.template-collection').find('.grid__item--sidebar .collection-sidebar__group--2 button').click(); 
  $('.collection-filter__btn').click(function(){
    $('.collection-filter__item--right ul').toggleClass('hide');
  });
});



 